import { useCallback, useMemo } from "react";
import debounce from "lodash.debounce";
import Search from "antd/lib/input/Search";

type SearchInputProps = {
  placeholder: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

function SearchInput(props: SearchInputProps) {
  const { onChange, placeholder, disabled = false } = props;

  const debouncedSearch = useMemo(
    () =>
      debounce((val) => {
        onChange(val);
      }, 500),
    [onChange]
  );

  const handleChange = useCallback(
    (e: React.FormEvent) => {
      debouncedSearch((e.target as HTMLInputElement).value);
    },
    [debouncedSearch]
  );

  return (
    <div className="w-[225px] py-1">
      <Search
        type="text"
        placeholder={placeholder || "Search"}
        onInput={handleChange}
        disabled={disabled}
      />
    </div>
  );
}

export default SearchInput;
